import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import {
    type IsoAndUnixTimestamp,
    nowIsoAndUnix,
} from "../../date-time/iso-and-unix";
import type { packageStatus } from "../shipping/package-status";
import type { ShipmentPackageId } from "./shipment-package-id";

type ShipmentPackage = {
    readonly _id: ShipmentPackageId;
    readonly _type: "PACKAGE";
    readonly _createdAt: IsoAndUnixTimestamp;

    readonly status: packageStatus;
};

const shipmentPackageFactory = (
    params: Except<ShipmentPackage, "_id" | "_type" | "_createdAt">,
): ShipmentPackage => {
    return {
        ...params,
        _id: generateId({ prefix: "package__" }),
        _type: "PACKAGE",
        _createdAt: nowIsoAndUnix(),
    };
};

export { shipmentPackageFactory };
export type { ShipmentPackage };
